import { z } from 'zod';

import type { ZodUseQuery } from '@/utils/zodReactQuery';

const groundingDaySchema = z.object({
	day: z.string(),
	checks: z.number().int().nonnegative(),
	clean: z.number().int().nonnegative(),
	flagged: z.number().int().nonnegative(),
	scrubbed: z.number().int().nonnegative(),
	errors: z.number().int().nonnegative(),
});

export const groundingQualityResponse = z.object({
	windowDays: z.number().int().positive(),
	checks: z.number().int().nonnegative(),
	clean: z.number().int().nonnegative(),
	flagged: z.number().int().nonnegative(),
	scrubbed: z.number().int().nonnegative(),
	errors: z.number().int().nonnegative(),
	contradictions: z.number().int().nonnegative(),
	unsupportedClaims: z.number().int().nonnegative(),
	// Null when there were no checks in the window: "no data", never 0 %.
	verifiedRate: z.number().min(0).max(1).nullable(),
	byDay: z.array(groundingDaySchema),
});

export type GroundingQuality = z.infer<typeof groundingQualityResponse>;
export type UseGroundingQuality = ZodUseQuery<GroundingQuality, { days: number }>;
